/* ------------------------------------------------------------
 * Montrose Cosmetics — apparitions au défilement
 *
 * Deux niveaux seulement :
 *  1. quelques compositions éditoriales explicitement choisies montent
 *     en deux ou trois temps ;
 *  2. les autres sections reçoivent un fondu très léger d'un seul bloc.
 *
 * Rien n'est masqué en Liquid. Sans JavaScript ou avec la préférence
 * « réduire les animations », tout le contenu reste immédiatement visible.
 * ------------------------------------------------------------ */

(function () {
  'use strict';

  /* Les éléments d'une grille ou d'un carrousel restent groupés : animer
     chaque carte créait des trous et cassait la continuité du défilement. */
  var GROUPS = [
    {
      root: '.mon-besoins',
      units: '.mon-besoins__header, .mon-besoins__scroller',
    },
    {
      root: '.mon-soins',
      units: '.mon-soins__header, .mon-soins__grid',
    },
    {
      root: '.mon-preuves',
      units: '.mon-preuves__header, .mon-preuves__columns, .mon-preuves__disclaimer, .mon-preuves__naturalite',
    },
    {
      root: '.mon-soon',
      units: '.mon-soon__head, .mon-soon__grid, .mon-soon__notify',
    },
  ];

  var MAX_STEPS = 3;
  var STEP_MS = 90;
  var DURATION_MS = 740;

  function ensureStyles() {
    if (document.getElementById('mm-reveal-styles')) return;

    var style = document.createElement('style');
    style.id = 'mm-reveal-styles';
    style.textContent =
      '.mm-reveal{' +
      'opacity:0!important;' +
      'transform:translate3d(0,18px,0)!important;' +
      'transition:opacity .66s cubic-bezier(.22,1,.36,1),transform .74s cubic-bezier(.22,1,.36,1)!important;' +
      'transition-delay:calc(var(--mm-reveal-i,0)*90ms)!important' +
      '}' +
      '.mm-reveal.is-in{' +
      'opacity:1!important;' +
      'transform:translate3d(0,0,0)!important' +
      '}' +
      '.mm-reveal.mm-reveal--soft{' +
      'opacity:.86!important;' +
      'transform:none!important;' +
      'transition:opacity .55s ease-out!important;' +
      'transition-delay:0s!important' +
      '}' +
      '.mm-reveal.mm-reveal--soft.is-in{opacity:1!important}' +
      '@media (prefers-reduced-motion:reduce){' +
      '.mm-reveal,.mm-reveal.is-in{' +
      'opacity:1!important;' +
      'transform:none!important;' +
      'transition:none!important' +
      '}' +
      '}';

    document.head.appendChild(style);
  }

  function clear(el) {
    el.classList.remove('mm-reveal', 'mm-reveal--soft', 'is-in');
    el.style.removeProperty('--mm-reveal-i');
  }

  function revealGroup(root, units) {
    var last = 0;

    units.forEach(function (el, i) {
      el.classList.add('is-in');
      var done = Math.min(i, MAX_STEPS) * STEP_MS + DURATION_MS + 100;
      if (done > last) last = done;
      window.setTimeout(clear, done, el);
    });

    window.setTimeout(function () {
      root.querySelectorAll('.mm-reveal').forEach(clear);
    }, last + 160);
  }

  function skippable(el) {
    if (!(el instanceof Element)) return true;
    if (el.hidden || el.getAttribute('aria-hidden') === 'true') return true;

    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden') return true;
    if (cs.position === 'fixed' || cs.position === 'sticky' || cs.position === 'absolute') return true;

    var r = el.getBoundingClientRect();
    return r.width < 2 || r.height < 2;
  }

  function watchGroup(root, units) {
    units = units.filter(function (el) {
      return !skippable(el);
    });
    if (!units.length) return;

    units.forEach(function (el, i) {
      el.classList.add('mm-reveal');
      el.style.setProperty('--mm-reveal-i', Math.min(i, MAX_STEPS));
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting && entry.boundingClientRect.bottom < 0) {
            observer.disconnect();
            units.forEach(clear);
            return;
          }
          if (!entry.isIntersecting) return;
          observer.disconnect();
          revealGroup(root, units);
        });
      },
      /* Déclenche légèrement avant l'entrée dans l'écran : le contenu est
         déjà en mouvement quand le regard arrive dessus. */
      { threshold: 0, rootMargin: '0px 0px 7% 0px' }
    );

    observer.observe(root);
  }

  /* Les zones ayant leur propre animation, les interfaces et le footer ne
     reçoivent jamais le fondu global. */
  var SKIP_SECTION =
    '.mnh, [data-mnh-reveal], .mon-gammes, .mon-produit-benefices, .mr-hero, .mr-reveal, [data-mr-stagger], .mon-footer, [data-mm-reveal-skip], dialog[open]';

  var siteObserver = null;
  var pending = [];
  var ticking = false;

  function siteReveal(entries) {
    entries.forEach(function (entry) {
      var el = entry.target;

      if (!entry.isIntersecting && entry.boundingClientRect.bottom < 0) {
        siteObserver.unobserve(el);
        clear(el);
        return;
      }
      if (!entry.isIntersecting) return;

      siteObserver.unobserve(el);
      el.classList.add('is-in');
      window.setTimeout(clear, DURATION_MS + 120, el);
    });
  }

  /* En cas de défilement très rapide, ne jamais laisser une section dans
     son état atténué si elle a été dépassée entre deux observations. */
  function sweep() {
    ticking = false;
    var h = window.innerHeight || document.documentElement.clientHeight;
    var entering = [];

    pending = pending.filter(function (el) {
      if (!el.isConnected || !el.classList.contains('mm-reveal') || el.classList.contains('is-in')) return false;

      var r = el.getBoundingClientRect();
      if (r.bottom < 0) {
        siteObserver.unobserve(el);
        clear(el);
        return false;
      }
      if (r.top < h * 1.08 && r.bottom > 0 && r.width > 0) {
        entering.push({ target: el, isIntersecting: true, boundingClientRect: r });
        return false;
      }
      return true;
    });

    if (entering.length) siteReveal(entering);
  }

  function onScroll() {
    if (ticking || !pending.length) return;
    ticking = true;
    window.requestAnimationFrame(sweep);
  }

  function initSections(reduce) {
    if (reduce || !('IntersectionObserver' in window)) return;
    if (document.documentElement.classList.contains('shopify-design-mode')) return;

    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var fold = viewportHeight * 0.94;

    if (!siteObserver) {
      siteObserver = new IntersectionObserver(siteReveal, {
        threshold: 0,
        rootMargin: '0px 0px 10% 0px',
      });
    }

    document.querySelectorAll('.shopify-section').forEach(function (section) {
      if (section.dataset.mmRevealReady === '1') return;
      section.dataset.mmRevealReady = '1';

      if (section.closest('[class*="header-group"], [id*="header-group"]')) return;
      if (/header|announcement|cart-drawer|drawer|popup|modal|overlay/i.test(section.id)) return;
      if (section.matches(SKIP_SECTION) || section.querySelector(SKIP_SECTION)) return;
      if (skippable(section)) return;

      var r = section.getBoundingClientRect();
      /* Le hero et tout ce qui est déjà visible au chargement restent fixes. */
      if (r.top < fold) return;

      section.classList.add('mm-reveal', 'mm-reveal--soft');
      siteObserver.observe(section);
      pending.push(section);
    });

    if (!initSections.bound) {
      initSections.bound = true;
      document.addEventListener('scroll', onScroll, { passive: true, capture: true });
      window.addEventListener('resize', onScroll, { passive: true });
    }
  }

  function init() {
    ensureStyles();

    var reduce =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    GROUPS.forEach(function (group) {
      document.querySelectorAll(group.root).forEach(function (root) {
        var section = root.closest('.shopify-section');
        if (section) section.dataset.mmRevealReady = '1';
        if (root.dataset.mmRevealReady === '1') return;
        root.dataset.mmRevealReady = '1';

        if (reduce || !('IntersectionObserver' in window)) return;
        watchGroup(root, [].slice.call(root.querySelectorAll(group.units)));
      });
    });

    initSections(reduce);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
